// extracted by mini-css-extract-plugin
export var actions = "_4f-0";
export var actionsContainer = "_4f-6";
export var border = "_4f-1";
export var childFullHeight = "_4f-d";
export var collapse = "_4f-2";
export var content = "_4f-8";
export var contentChild = "_4f-c";
export var fullscreen = "_4f-a";
export var hasLeftRadius = "_4f-i";
export var headerContainer = "_4f-3";
export var headerRow = "_4f-5";
export var hidePadding = "_4f-9";
export var navCollapsedGap = "_4f-j";
export var noScrollX = "_4f-k";
export var noScrollY = "_4f-l";
export var noTopPadding = "_4f-g";
export var optOutTopPadding = "_4f-b";
export var pageMain = "_4f-h";
export var pageOuter = "_4f-e";
export var pagePadding = "_4f-7";
export var profile = "_4f-m";
export var profileContainer = "_4f-n";
export var profileImage = "_4f-o";
export var profileMain = "_4f-p";
export var profileSubtitle = "_4f-r";
export var profileTitle = "_4f-q";
export var showLeftPadding = "_4f-f";
export var tabsWrapper = "_4f-4";
export var title = "_4f-s";